import * as React from 'react';

import { SVGProps } from '../../types';

export const IconGenerateQuestionsSvg = ({
  title,
  titleId,
  ...props
}: SVGProps) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    focusable="false"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}

    <path
      d="M7.5 5C7.5 3.89543 8.39543 3 9.5 3H30C31.1046 3 32 3.89543 32 5V33C32 34.1046 31.1046 35 30 35H9.5C8.39543 35 7.5 34.1046 7.5 33V5Z"
      fill="#E4FBFF"
    />
    <rect
      x={5.5}
      y={1}
      width={24.5}
      height={32}
      rx={2}
      stroke="#0099C7"
      strokeWidth={1.5}
    />
    <path
      d="M10.75 6.75L25.25 6.75"
      stroke="#0099C7"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.75 10.75L18.25 10.75"
      stroke="#0099C7"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4178 19.5026C19.5238 19.1827 19.9762 19.1827 20.0822 19.5026L20.7803 21.609C20.9542 22.134 21.366 22.5458 21.891 22.7197L23.9974 23.4178C24.3173 23.5238 24.3173 23.9762 23.9974 24.0822L21.891 24.7803C21.366 24.9542 20.9542 25.366 20.7803 25.891L20.0822 27.9974C19.9762 28.3173 19.5238 28.3173 19.4178 27.9974L18.7197 25.891C18.5458 25.366 18.134 24.9542 17.609 24.7803L15.5026 24.0822C15.1827 23.9762 15.1827 23.5238 15.5026 23.4178L17.609 22.7197C18.134 22.5458 18.5458 22.134 18.7197 21.609L19.4178 19.5026Z"
      fill="#0099C7"
    />
    <path
      d="M14.3374 15.4095C14.3958 15.2623 14.6042 15.2623 14.6626 15.4095L15.2162 16.8033C15.3941 17.2512 15.7488 17.6059 16.1967 17.7838L17.5905 18.3374C17.7377 18.3958 17.7377 18.6042 17.5905 18.6626L16.1967 19.2162C15.7488 19.3941 15.3941 19.7488 15.2162 20.1967L14.6626 21.5905C14.6042 21.7377 14.3958 21.7377 14.3374 21.5905L13.7838 20.1967C13.6059 19.7488 13.2512 19.3941 12.8033 19.2162L11.4095 18.6626C11.2623 18.6042 11.2623 18.3958 11.4095 18.3374L12.8033 17.7838C13.2512 17.6059 13.6059 17.2512 13.7838 16.8033L14.3374 15.4095Z"
      fill="#0099C7"
    />
  </svg>
);
